import { render, staticRenderFns } from "./updateCoordinates.vue?vue&type=template&id=139c3f26&"
import script from "./updateCoordinates.vue?vue&type=script&lang=js&"
export * from "./updateCoordinates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports